<script setup>
import { ref, onMounted } from 'vue'
import { useInitPortalStore } from '@/composables/use-init-portal-store'

import { useWebSiteStore } from '@/stores/web-site.store'
import i18n from '@/plugins/i18n'
import { useAuthService } from '@/services/auth.service'

const { tryInitPortalStoreAsync } = useInitPortalStore()

await tryInitPortalStoreAsync()

const webSiteStore = useWebSiteStore()

const { redirectToAuth } = useAuthService()

const isLoggingIn = ref(false)

const login = () => { redirectToAuth() }

const code = new URLSearchParams(window.location.search).get('code')

onMounted(async() => {
  if (code) {
    isLoggingIn.value = true
    await webSiteStore.loginAsync({code: code})
    isLoggingIn.value = false
  } else {
    setTimeout(() => { login() }, 1000)
  }
})

const action = code ? i18n.global.t('login.loggingIn') : i18n.global.t('login.verifying')
const loggingDots = ref('.')
setInterval(() => {
  loggingDots.value = loggingDots.value.length < 3 ? loggingDots.value + '.' : '.'
}, 1000)

</script>

<template>
  <q-layout
    id="login-layout"
    view="hHh Lpr lFf"
  >
    <q-page-container>
      <q-page
        class="window-height row justify-center items-center"
      >
        <div class="column text-white justify-center ">
          <div class="container ">
            <div class="content">
              <transition
                appear
                name="slide-fade"
              >
                <img

                  src="@/assets/logo.svg"
                  alt="Logo"
                  class="logo"
                >
              </transition>
              <div class="action">
                {{ action }} {{ loggingDots }}
              </div>
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<style scoped lang="scss">
@import '@/styles/quasar.variables.scss';

.container {
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  height: 95vh;
  width: 100%;
}
.content {
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
}
.logo {
  display: flex;
  height: 12rem;
}
.action {
  font-size: 1.5rem;
  margin-top: 2rem;
  color: #888;
  width: 100%;
}

.login-container {
  width: 50rem;
  max-width: 100%;
  margin: 0 auto;
}

.login-btn {
  max-width: 12rem;
  min-width: 12rem;
  max-height: 2rem;
}

</style>
